import {asyncRoutes} from '@/router'

// 将菜单信息转成对应的路由信息 动态添加
export default function createRoutes(data) {
  const result = []
  const children = []
  children.push({
      path: '/home',
      name: 'Centre',
      component: () => import('@/views/centre'),
    },
  )
  data.forEach(item => {
    generateRoutes(children, item)
  })
  result.push({
    path: '/main',
    name: 'layout',
    component: () => import('@/views/layout'),
    children,
  })
  return result
}

function generateRoutes(children, item) {
  if (item.code) {
    if (asyncRoutes[item.code]) children.push(asyncRoutes[item.code])
  }
  if (item.children) {
    item.children.forEach(e => {
      generateRoutes(children, e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/util/createRoutes.js